module.exports = __webpack_public_path__ + "static/media/user-minus.acd6464a.svg";